// extracted by mini-css-extract-plugin
export default {"displaytimer":"Timerpage_displaytimer__DY8Wo","text":"Timerpage_text__rnAMb","hstack":"Timerpage_hstack__Xoeoo"};